import {ColorPalette} from './colorPalette';
import type {ColorMode} from './types';

/**
 * Background color sets for {@link Card}, keyed by background name and color
 * mode. The source of truth for the {@link BackgroundColor} type.
 */
export const backgroundColors = {
  primary: {
    main: ColorPalette.lightBeige,
    light: ColorPalette.offWhite,
    dark: ColorPalette.brown,
  },
  secondary: {
    main: ColorPalette.secondary.dirtyLightGreen,
    light: ColorPalette.offWhite,
    dark: ColorPalette.brown,
  },
  topBar: {
    main: ColorPalette.burgundy,
    light: ColorPalette.offWhite,
    dark: ColorPalette.burgundy,
  },
} satisfies Record<string, Record<ColorMode, string>>;

export type BackgroundColor = keyof typeof backgroundColors;
